import React, {useContext} from 'react';

import {ZeroModels} from '../../ModelRegistry/ZeroModels';
import {ArtifactCollectionCards} from '../Registry/ArtifactCollectionCards';
import {SDKVersionProvider} from '../Registry/SDKVersionContext';
import {ZeroCollections} from '../Registry/ZeroCollections';
import {SingleRegistrySearchContext} from './RegistriesSearchContextProvider';
import {RegistrySearchCollectionType} from './types';
import {globalRegistryType} from './utils';

type CollectionsTabProps = {
  totalCount: number;
  currentPaginatedCollections: RegistrySearchCollectionType[];
  refetchCollections: () => void;
  setShowNewCollectionModal: (show: boolean) => void;
  collectionsLoading: boolean;
  totalCollectionsLoaded: number;
  page: number;
  pageSize: number;
  hasNextPage: boolean;
  onPageChange: (page: number) => void;
  registry?: globalRegistryType; // If undefined, this is a legacy model registry
};

export const CollectionsTab = ({
  totalCount,
  currentPaginatedCollections,
  refetchCollections,
  setShowNewCollectionModal,
  collectionsLoading,
  totalCollectionsLoaded,
  page,
  pageSize,
  hasNextPage,
  onPageChange,
  registry,
}: CollectionsTabProps) => {
  const {searchFilter} = useContext(SingleRegistrySearchContext);
  const isZeroCollections =
    !collectionsLoading && totalCollectionsLoaded === 0 && !searchFilter;

  return (
    // SDKVersionProvider needed for ZeroVersions code snippet for Registries.
    // Since this is sharing the same collection component, we need to also include it here.
    <SDKVersionProvider>
      {isZeroCollections ? (
        // Placeholder if this registry has no collections yet
        <ZeroCollectionCards
          onCreateCollection={() => setShowNewCollectionModal(true)}
          globalRegistry={registry}
        />
      ) : (
        <ArtifactCollectionCards
          totalCount={totalCount}
          currentPaginatedCollections={currentPaginatedCollections}
          page={page}
          setPage={onPageChange}
          refetchCollections={refetchCollections}
          collectionsLoading={collectionsLoading}
          totalCollectionsLoaded={totalCollectionsLoaded}
          hasNextPage={hasNextPage}
          pageSize={pageSize}
          protectedAliases={registry?.protectedAliases}
        />
      )}
    </SDKVersionProvider>
  );
};

const ZeroCollectionCards = ({
  onCreateCollection: onCreate,
  globalRegistry,
}: {
  onCreateCollection: () => void;
  globalRegistry?: globalRegistryType;
}) => {
  return globalRegistry === undefined ? (
    // ... for legacy model registry
    <ZeroModels onCreateModel={onCreate} />
  ) : (
    // ... for global registry
    <ZeroCollections onCreateCollection={onCreate} registry={globalRegistry} />
  );
};
